import { createContext } from "react";

export const SideNavContext = createContext<SideNavContextProps | null>(null);

interface SideNavContextProps {
    registerOnClose: (onCloseCb: any) => void;
}
